import { getNextTransition } from '@wix/ambassador-funnel-builder-v2-flow-context/http'
import { getPageContent } from '@wix/ambassador-funnel-builder-v2-page/http'
import {
  FlowContext,
  FunnelBuilderService,
  GetPageContentParams,
  Page,
  pageMapper,
  Transition,
  transitionMapper,
} from '@wix/funnel-builder-lizard'

import { FlowMonitoring } from '../../monitoring/FlowMonitoring'
import { withMonitoring } from '../../monitoring/withMonitoring'
import { ambassadorHttpClient } from '../httpClient'

export class HttpFunnelBuilderService implements FunnelBuilderService {
  private monitoring: FlowMonitoring

  constructor(flowId: string) {
    this.monitoring = new FlowMonitoring(flowId)
  }

  async getNextTransition(flowContext: FlowContext): Promise<Transition> {
    const request = getNextTransition({ flowContext })
    const { data } = await withMonitoring(() => ambassadorHttpClient.request(request), 'getNextTransition')

    const originPageId = flowContext.historyEntries[flowContext.historyEntries.length - 1]!.pageId!
    await this.monitoring.sendTransitionStarted({
      originId: originPageId,
      destinationId: data.transition!.internal?.targetPageId,
      isExternal: Boolean(data.transition?.external),
    })

    return transitionMapper.toDomain(data.transition!)
  }

  async getPageContent({
    flowContext,
    pageId: requestPageId,
    forceLanguage,
    debugTranslationKeys,
  }: GetPageContentParams): Promise<Page> {
    const historyEntries = flowContext?.historyEntries
    const snapshotId = historyEntries ? historyEntries[historyEntries.length - 1]?.snapshotId : undefined
    const pageId = requestPageId ? requestPageId : historyEntries![historyEntries!.length - 1]!.pageId!

    const request = getPageContent({ pageId, flowContext, snapshotId, forceLanguage, debugTranslationKeys })
    const { data } = await withMonitoring(() => ambassadorHttpClient.request(request), 'getPageContent')
    await Promise.all([
      this.monitoring.sendPageView({ pageId }),
      this.monitoring.sendTransitionFinished({ destinationId: pageId }),
    ])

    return pageMapper.toDomain(data.page!)
  }

  async initFlowContext(): Promise<FlowContext> {
    throw new Error('Not implemented')
  }
}
